export const UserServiceEndpoint = '/user-api/v1/rest';
export const ChannelServiceEndpoint = '/channel-api/v1/rest';
